<template>
  <div class="input-select">
    <el-input  v-bind="$attrs" @blur="handleBlur" :class="inputClass" :style="inputStyle"  v-model="inputValue"/>
    <div class="select">
      <span class="label">通配符:</span>
      <div class="list">
        <div class="list-item" v-for="item in list" :key="item.value">
          <span @click="handleItemClick(item)" :class="inputData.includes(item.value)?'active':''">
            <i :class="inputData.includes(item.value)?'el-icon-minus':'el-icon-plus' "/>{{item.label}}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: ()=>[]
    },
    inputClass: {
      type: String,
      default: ''
    },
    inputStyle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {
    inputData() {
     return [...this.value.matchAll(/\{[^\{]*?\}|(wk)/g)].map(v=> {
      return v[0] ==='wk'?v[0] : v[0].slice(1, -1)
     })
    },
    inputValue: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v )
      }
    }
  },
  methods: {
    handleItemClick(data) {
      const i = this.inputData.indexOf(data.value);
      if (data.value ==='wk') {
         const s = (this.value || '').trim()?`${this.value}-${data.value}`:`${data.value}`
        this.$emit('input', s);
        return;
      }
      if (i>-1) {
       return;
      }else {
        const s = (this.value || '').trim()?`${this.value}-{${data.value}}`:`{${data.value}}`
        this.$emit('input', s)
      }
      this.$emit('tab-click', data)
    },
     handleBlur() {
        if (!(this.value.indexOf('{创建日期}')>-1 && this.value.indexOf('{任务号-顺序号}')>-1)) {
          this.$alert('无创建日期与任务号-顺序号通配符会导致名称重复，请注意', '提示', {
            confirmButtonText: '已知晓',
            callback: action => {}
          })
        }
      },
  },
  watch: {
    inputValue(n) {
      this.$emit('change', n)
    }
  }
}
</script>

<style lang="scss" scoped>
.input-select {
  .select {
    display: flex;
    .label {
      width: 50px;
      color: #7F7F7F;
      font-size: 12px;
    }
  }
  .list {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    width: 0;
    &-item {
      margin: 0 4px;
      span {
        font-size: 12px;
        border: 1px solid #7F7F7F;
        border-radius: 4px;
        padding: 4px 8px;
        color: #7F7F7F;
        cursor: pointer;
        &.active {
           border: 1px solid #409EFF;
           color: #409EFF;
        }
      }
    }
  }
}
</style>